<template>
    <div>
        <!-- Table section -->
            <v-overlay :value="overlay">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>

            <v-card>
                <v-card-title>
                    <v-row>

                        <v-col cols="12" md="4" sm="12">
                            <v-btn outlined href="#graph">
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#000000"><path d="M154.8,6.88c-3.80281,0 -6.88,3.07719 -6.88,6.88c0,1.00781 0.25531,1.935 0.645,2.795l-27.52,38.485c-0.215,-0.01344 -0.43,0 -0.645,0c-1.37062,0 -2.6875,0.37625 -3.7625,1.075l-23.7575,-11.825c-0.22844,-3.60125 -3.225,-6.45 -6.88,-6.45c-3.80281,0 -6.88,3.07719 -6.88,6.88c0,0.36281 0.05375,0.72563 0.1075,1.075l-25.155,19.995c-0.76594,-0.29562 -1.59906,-0.43 -2.4725,-0.43c-3.44,0 -6.26187,2.51281 -6.7725,5.805l-23.435,9.46c-1.16906,-0.91375 -2.60687,-1.505 -4.1925,-1.505c-3.80281,0 -6.88,3.07719 -6.88,6.88c0,3.80281 3.07719,6.88 6.88,6.88c3.46688,0 6.30219,-2.56656 6.7725,-5.9125l23.435,-9.3525c1.16906,0.91375 2.60688,1.505 4.1925,1.505c3.80281,0 6.88,-3.07719 6.88,-6.88c0,-0.36281 -0.05375,-0.72562 -0.1075,-1.075l25.155,-19.995c0.76594,0.29563 1.59906,0.43 2.4725,0.43c1.37063,0 2.6875,-0.37625 3.7625,-1.075l23.7575,11.825c0.22844,3.60125 3.225,6.45 6.88,6.45c3.80281,0 6.88,-3.07719 6.88,-6.88c0,-1.00781 -0.25531,-1.935 -0.645,-2.795l27.52,-38.485c0.215,0.01344 0.43,0 0.645,0c3.80281,0 6.88,-3.07719 6.88,-6.88c0,-3.80281 -3.07719,-6.88 -6.88,-6.88zM141.04,51.6v120.4h27.52v-120.4zM147.92,58.48h13.76v106.64h-13.76zM72.24,82.56v89.44h27.52v-89.44zM79.12,89.44h13.76v75.68h-13.76zM106.64,99.76v72.24h27.52v-72.24zM113.52,106.64h13.76v58.48h-13.76zM37.84,110.08v61.92h27.52v-61.92zM44.72,116.96h13.76v48.16h-13.76zM3.44,123.84v48.16h27.52v-48.16zM10.32,130.72h13.76v34.4h-13.76z"></path></g></g></svg>
                                <span style="margin-left: 5px;">
                                    {{ $t("graph") }}
                                </span>
                            </v-btn>
                        </v-col>

                        <v-spacer></v-spacer>
                        <v-col cols="6" md="2" sm="6">
                            <v-menu
                                v-model="menuDateFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="from_date"
                                        :label="$t('dateFrom')"
                                        prepend-inner-icon="mdi-calendar"
                                        outlined
                                        dense
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    :first-day-of-week="0"
                                    v-model="from_date"
                                    @input="menuDateFrom = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="6" md="2" sm="6">

                            <v-menu
                                v-model="menuDateTo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="to_date"
                                        :label="$t('dateTo')"
                                        prepend-inner-icon="mdi-calendar"
                                        outlined
                                        dense
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    :first-day-of-week="0"
                                    v-model="to_date"
                                    @input="menuDateTo = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="6" md="2" sm="6">
                            <v-text-field
                                v-model="search"
                                :label="$t('search')"
                                single-line
                                outlined
                                dense
                                clearable
                            >
                            </v-text-field>
                        </v-col>

                         <v-col cols="12" md="2" sm="12">
                            <v-btn class="mr-6" dark color="blue-grey" elevation="2" outlined text @click="handleSearch()">
                                <v-icon class="mr-1"> mdi-magnify </v-icon>
                            </v-btn>

                            <v-btn @click="exportExcel('exportExcel')" outlined>
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#000000"><path d="M24.08,6.88v158.24h104.22125l-5.85203,-6.88h-91.48922v-144.48h65.36v44.66625h44.72v41.33375h6.88v-46.09735l-0.88015,-0.88015c-0.12384,-0.15136 -0.26193,-0.28928 -0.40985,-0.41656l-45.49265,-45.48594zM103.2,18.57734l32.9689,33.02266h-32.9689zM58.97719,65.36l18.12047,30.96l-19.78,30.96h16.56844l10.77015,-19.98156c0.74992,-1.92984 1.23813,-3.40447 1.44453,-4.34703h0.1075c0.42656,2.01928 0.84393,3.38883 1.24297,4.13875l10.76344,20.19656h16.46766l-19.05438,-31.27578l18.53703,-30.65094h-15.53375l-9.83625,18.32875c-0.946,2.39424 -1.61772,4.28522 -1.9686,5.48922h-0.10078c-0.54352,-2.01928 -1.16949,-3.81894 -1.86781,-5.28094l-8.90235,-18.53703zM130.72,106.64v30.96h-17.2l29.22656,34.4l29.25344,-34.4h-17.2v-30.96zM137.6,113.52h10.32v30.96h8.94265l-14.11609,17.2l-14.08922,-17.2h8.94265z"></path></g></g></svg>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-data-table
                    id="exportExcel"
                    :loading="loading"
                    :headers="headers"
                    :items="listCropCollectPlaning"
                    :search="search"
                    hide-default-footer
                    class="elevation-1"
                    :server-items-length="totalPage"
                    :items-per-page="itemsPerPage"
                    :page.sync="currentPage"
                    :options.sync="options"
                    :mobile-breakpoint="0"
                >
                    <!-- Header -->
                    <template v-slot:progress class="text-center"><v-progress-circular indeterminate color="green" :value="50"></v-progress-circular></template>
                    <template v-slot:header.collection_date="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.created_name="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.crop_name_product="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.estimate_quantity="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.price_on_field="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.village_name="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.commune_name="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.district_name="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.province_name="{ header }">{{ $t(header.text) }}</template>

                    <!-- Body section -->
                    <template v-slot:item.collection_date="{ item }">{{ item.collection_date | dateFormat}}</template>
                    <template v-slot:item.created_name="{ item }">{{ item.created_name }}</template>
                    <template v-slot:item.crop_name_product="{ item }">{{ item.crop_name_product }}</template>
                    <template v-slot:item.estimate_quantity="{ item }">{{ item.estimate_quantity | formatNumber }} តោន</template>
                    <template v-slot:item.price_on_field="{ item }">{{ (item.price_on_field ? item.price_on_field : 0) | formatNumber }} {{ getCurrencySymbol(item.currency_code) }} / {{ item.unit_price }}</template>
                    <template v-slot:item.village_name="{ item }">{{ item.village_name }}</template>
                    <template v-slot:item.commune_name="{ item }">{{ item.commune_name }}</template>
                    <template v-slot:item.district_name="{ item }">{{ item.district_name }}</template>
                    <template v-slot:item.province_name="{ item }">{{ item.province_name }}</template>
                </v-data-table>

                <!-- Pagination -->
                <div class="text-center pt-2">
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-col v-if="!$vuetify.breakpoint.xsOnly" class="d-flex" cols="12" sm="1">{{ $t("total") }} : {{ totalPage }}</v-col>
                        <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
                            <v-select
                                :label="$t('perPage')"
                                v-model="itemsPerPage"
                                :items="pageList"
                            ></v-select>
                        </v-col>

                        <v-pagination
                            v-model="currentPage"
                            :length="pageCount"
                            circle
                            prev-icon="mdi-menu-left"
                            next-icon="mdi-menu-right"
                            :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
                        ></v-pagination>

                        <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
                            <v-text-field
                                v-model="currentPageComputed"
                                :max="pageCount"
                                min="1"
                                type="number"
                                :label="$t('goto')"
                            ></v-text-field>
                        </v-col>
                    </v-card-actions>
                </div>
            </v-card>
        <!-- End Table section -->

         <v-card id="graph" style="margin-top: 50px;">
            <v-card-text>
                  
                <div style="float: right">
                    <v-autocomplete
                        v-model="product_id"
                        :items="productList"
                        outlined
                        dense
                        item-text="text"
                        item-value="id"
                        name="product_id"
                        id="product_id"
                    >
                    </v-autocomplete>
                </div>
                <div style="float: right; line-height: 2.5; margin-right: 10px;">
                    <label for="product_id">{{ $t('paddy_type') }}</label>
                </div>
                <div style="clear:both"></div>

                <div style="border: 1px solid #cecece; border-radius: 5px;">
                    <v-progress-linear
                    v-if="graph_loading"
                    indeterminate
                    color="blue"
                    ></v-progress-linear>
                    <v-row>
                        <v-col cols="12">
                            <h2 v-if="chartData.rows == 0" style="text-align: center; position: relative; top: 50%;-ms-transform: translateY(-50%); transform: translateY(-50%);">{{ $t('emptyData') }}</h2>
                            <ve-line :data="chartData"></ve-line>
                        </v-col>
                    </v-row>
                </div>
                        
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import MainMixin from "../../../mixins/mainMixin";
    import OptionDataMixin from "../../../mixins/optionDataMixin";
    import {provider} from "@/service/provider";
    import axios from "axios";
    import _ from "lodash";


    export default {
        name: "buybackCropCollectPlaning",
        mixins: [MainMixin, OptionDataMixin],
        data() {
            this.chartSettings = {
                metrics: ['cost', 'profit'],
                dimension: ['date']
            };
            return {
                graph_loading: false,
                product_id: "62", // PK10001 - ស្រូវផ្ការំដួល
                productList: [],
                chartData: {},

                headers: [
                    {text: "collectionDate", value: "collection_date", filterable: false},
                    {text: "cropTrader", value: "created_name"},
                    {text: "paddy_type", value: 'crop_name_product'},
                    {text: "estimateQuantity", value: "estimate_quantity", align: "center"},
                    {text: "priceOnField", value: "price_on_field", align: "center"},
                    {text: "village", value: "village_name"},
                    {text: "commune", value: "commune_name"},
                    {text: "district", value: "district_name"},
                    {text: "province", value: "province_name"},
                ],
            };
        },

        methods: {

            fetchDataTable: _.debounce(function () {
                let vm = this;
                vm.fetchListCropCollectPlaning({
                    search: vm.search,
                    id: "",
                    offset: vm.currentPage,
                    limit: vm.itemsPerPage,
                    sortBy: vm.options.sortBy[0] || "created_at",
                    sortDesc: vm.options.sortDesc[0] === false ? 0 : 1,
                    from_date: vm.from_date,
                    to_date: vm.to_date,
                })
            }, 350),

            handleSearch(){
                this.fetchDataTable();
            },

            handleProduct(product_id){
                this.graph_loading = true;
                let url = provider.baseURL + provider.getPaddyGraph;

                axios.post(url, {product_id: product_id}, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            this.graph_loading = false;
                            this.chartData = res.data.data;
                        }
                    },
                    error => {
                        console.log(error)
                    }
                );
            },

            fetchProduct(){
                let url = provider.baseURL + provider.getProductPaddy;

                axios.post(url, {}, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            this.productList = res.data.data.products;
                        }
                    },
                    error => {
                        console.log(error)
                    }
                );
            }

        },
        computed: {},
        watch: {
            product_id(val){
                this.handleProduct(val)
            },
            currentPage() {
                this.loading = true;
                this.fetchDataTable();
            },
            itemsPerPage() {
                this.loading = true;
                this.fetchDataTable();
            },
        },
        created() {
            this.fetchProduct();
            this.handleProduct(this.product_id);
        }
    };
</script>